export class PolyfillLoader {
  static load(): void {
    // IE11でいくつかの関数を使用するためのpolyfill
    // quillを参照から外したところ、StringのstartsWithとArrayのfindが使用できずエラーとなった。
    // quillのソース内の該当箇所を参考にpolyfillを移植した。（一般的なpolyfillの模様）
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
      };
    }

    if (!String.prototype.endsWith) {
      String.prototype.endsWith = function(searchString, position) {
        const subjectString = this.toString();
        if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
          position = subjectString.length;
        }
        position -= searchString.length;
        const lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
      };
    }

    if (!Array.prototype.find) {
      Object.defineProperty(Array.prototype, "find", {
        value(predicate: any) {
          if (this == null) {
            throw new TypeError("Array.prototype.find called on null or undefined");
          }
          if (typeof predicate !== "function") {
            throw new TypeError("predicate must be a function");
          }
          const list = Object(this);
          const length = list.length >>> 0;
          const thisArg = arguments[1];
          let value;

          for (let i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
              return value;
            }
          }
          return undefined;
        }
      });
    }
    // https://tc39.github.io/ecma262/#sec-array.prototype.findindex
    // tslintでエラー出る所は手当.
    if (!Array.prototype.findIndex) {
      Object.defineProperty(Array.prototype, "findIndex", {
        value: function(predicate: any) {
        // 1. Let O be ? ToObject(this value).
          if (this == null) {
            throw new TypeError('"this" is null or not defined');
          }

          const o = Object(this);

          // 2. Let len be ? ToLength(? Get(O, "length")).
          const len = o.length >>> 0;

          // 3. If IsCallable(predicate) is false, throw a TypeError exception.
          if (typeof predicate !== "function") {
            throw new TypeError("predicate must be a function");
          }

          // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
          const thisArg = arguments[1];

          // 5. Let k be 0.
          let k = 0;

          // 6. Repeat, while k < len
          while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return k.
            const kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
              return k;
            }
            // e. Increase k by 1.
            k++;
          }

          // 7. Return -1.
          return -1;
        },
        configurable: true,
        writable: true
      });
    }
    // https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
    if (!String.prototype.padStart) {
      Object.defineProperty(String.prototype, "padStart", {
        configurable: true,
        writable: true,
        value: function(targetLength: any, padString: any) {
          targetLength = targetLength >> 0; // floor if number or convert non-number to 0;
          padString = String(typeof padString !== "undefined" ? padString : " ");
          if (this.length > targetLength) {
            return String(this);
          } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
              padString += padString.repeat(targetLength / padString.length); // append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
          }
        },
      });
    }
    // https://github.com/korbinjoe/array-from-polyfill/blob/master/src/index.js
    if (!Array.from) {
      Array.from = (function() {
        const toStr = Object.prototype.toString;
        const isCallable = function(fn: any) {
          return typeof fn === "function" || toStr.call(fn) === "[object Function]";
        };
        const toInteger = function(value: any) {
          const valueNumber = Number(value);
          if (isNaN(valueNumber)) { return 0; }
          if (valueNumber === 0 || !isFinite(valueNumber)) { return valueNumber; }
          return (valueNumber > 0 ? 1 : -1) * Math.floor(Math.abs(valueNumber));
        };
        const maxSafeInteger = Math.pow(2, 53) - 1;
        const toLength = function(value: any) {
          const len = toInteger(value);
          return Math.min(Math.max(len, 0), maxSafeInteger);
        };
    
        // The length property of the from method is 1.
        return function from(arrayLike: null/*, mapFn, thisArg */) {
          // 1. Let C be the this value.
          // var C = this;
    
          // 2. Let items be ToObject(arrayLike).
          const items = Object(arrayLike);
    
          // 3. ReturnIfAbrupt(items).
          if (arrayLike == null) {
            throw new TypeError("Array.from requires an array-like object - not null or undefined");
          }
    
          // 4. If mapfn is undefined, then let mapping be false.
          const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
          let T;
          if (typeof mapFn !== "undefined") {
            // 5. else
            // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
            if (!isCallable(mapFn)) {
              throw new TypeError("Array.from: when provided, the second argument must be a function");
            }
    
            // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 2) {
              T = arguments[2];
            }
          }
    
          // 10. Let lenValue be Get(items, "length").
          // 11. Let len be ToLength(lenValue).
          const len = toLength(items.length);
    
          // 13. If IsConstructor(C) is true, then
          // 13. a. Let A be the result of calling the [[Construct]] internal method 
          // of C with an argument list containing the single item len.
          // 14. a. Else, Let A be ArrayCreate(len).
          const A = isCallable(this) ? Object(new (this as any)(len)) : new Array(len);

          // 16. Let k be 0.
          let k = 0;
          // 17. Repeat, while k < len… (also steps a - h)
          let kValue;
          while (k < len) {
            kValue = items[k];
            A[k] = mapFn ? (typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k)) : kValue;
            k += 1;
          }
          // 18. Let putStatus be Put(A, "length", len, true).
          A.length = len;
          // 20. Return A.
          return A;
        };
      }());
    }
  }
}
